import React, { useState, useEffect } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import { useFormik, Form, FormikProvider } from 'formik';
import {
  Grid,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
  CircularProgress,
  Backdrop,
  Autocomplete,
  TextField
} from '@material-ui/core';
import moment from 'moment';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import Controls from '../controls/Controls';
import { baseUrl, departments, services } from '../../utils/constants';
import { useClaimsContext } from '../../context/claims_context';

/* eslint-disable camelcase */
function ClaimsLineInit(props) {
  const { claimNo, getClaimDetailsById } = useClaimsContext();
  const { closePopup, claim_ID, service_Type_Id } = props;
  const [tariffCode, setTariffCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [tariffSearchName, setTariffName] = useState('');
  const [list, setList] = useState([]);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });

  const ClaimsLineSchema = Yup.object().shape({
    // amtClaimed: Yup.number().required('Charged Amount is Required')
  });
  const initialValue = {
    claim_Id: claim_ID,
    tarrif_id: 0,
    tarif_Code: '',
    period: '',
    mod: '',
    units: 1,
    dates: '',
    amtClaimed: 0.0,
    tariffAmt: 0.0,
    personalAc: 0.0,
    department_id: 0,
    serviceTypeId: 0,
    status_Code: '',
    amtPaid: 0.0,
    currency_id: 3,
    treatmentDate: '',
    overrideValidityPeriod: false,
    forceShortfall: false,
    shortfallAmt: 0.0,
    duplicateClaimId: 0,
    payeeType_Id: 0,
    userId: 0,
    savingsAmt: 0.0,
    applyModifiers: false,
    manuallyPay: false,
    manuallyPayAmt: 0.0
  };

  useEffect(() => {
    populateList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    validationSchema: ClaimsLineSchema,
    onSubmit: (values) => {
      console.log('claim line details ', values);
      saveClaimDetails(values);
    }
  });

  const saveClaimDetails = (line) => {
    const jsonClient = [];
    jsonClient.push(line);
    console.log('claim line b4 save', JSON.stringify(jsonClient[0]));
    fetch(`${baseUrl}/api/claims/saveClaimDetails`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(jsonClient[0])
    })
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('claim detail save result', result);
          notifyPopup(`Claim Detail Saved Successfully!`, 'success');
          getClaimDetailsById(claimNo);
          closePopup();
        },
        (error) => {
          notifyPopup(`Error in Saving Claim Line Detail!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const getTariffInfo = async (e) => {
    console.log('e at this point', tariffCode);
    if (tariffCode === '') {
      notifyPopup(`No Tariff Code # Selected, please enter number to search for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/claims/GetTariffByCodeCost?tariffCode=${tariffCode}`).then(
      (result) => {
        console.log('returned Tariff', result);
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Tariff Code not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned Tariff', result);
          if (result.data.result) {
            setTariffName(result.data.result.tariff_desc);
            formik.setFieldValue('tarrif_id', result.data.result.tariff_id);
            formik.setFieldValue('tarif_Code', result.data.result.tariff_code);
            formik.setFieldValue('amtClaimed', result.data.result.cost);
            formik.setFieldValue('tariffAmt', result.data.result.cost);
            formik.setFieldValue('department_id', result.data.result.dept_id);
            formik.setFieldValue('award', 'A');

            formik.setFieldValue('status_code', 'I');
            formik.setFieldValue('currency_id', 3);
            formik.setFieldValue('userId', sessionStorage.getItem('oldRefId'));
            // formik.setFieldValue('entryNo', result.data.result.entryNo);
          } else {
            setTariffName('Oooooppss.... Tariff Code not Found! - Please check the Code');
          }
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Tariff!: ${error}`, 'error');
      }
    );
  };

  const getTariffDescription = async (e) => {
    console.log('e at this point', e);
    if (e === '') {
      notifyPopup(`No Tariff Code # Selected, please enter number to search for!`, 'error');
      return;
    }
    setLoading(true);
    await axios(`${baseUrl}/api/claims/GetTariffByCodeCost?tariffCode=${e}`).then(
      (result) => {
        console.log('returned Tariff', result);
        setLoading(false);
        if (result.replyStatus === 1) {
          notifyPopup(`Tariff Code not Found!: ${result.replyMessage}`, 'error');
        } else {
          console.log('returned Tariff', result);
          if (result.data.result) {
            setTariffName(result.data.result.tariff_desc);
          } else {
            setTariffName('Oooooppss.... Tariff Code not Found! - Please check the Code');
          }
        }
      },
      (error) => {
        notifyPopup(`Error in Searching for Tariff!: ${error}`, 'error');
      }
    );
  };

  const populateList = async () => {
    await axios(`${baseUrl}/api/claims/GetTariffByCodeCostList?tariffCode=0`).then(
      (result) => {
        console.log('returned notes', result);
        setList(result.data.result);
      },
      (error) => {
        notifyPopup(`Error in getting students!: ${error}`, 'error');
      }
    );
  };

  const handleMouseDownPassword = (event) => {
    console.log('mouse down');
    event.preventDefault();
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const defprops = {
    options: list,
    getOptionLabel: (options) => `${options.tariff_desc} - $ ${options.cost}`
  };

  const { errors, touched } = formik;

  /* eslint-disable camelcase */
  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate>
        <Grid container spacing={2}>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={loading}
            onClick={handleLoadingClose}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
          <Grid item xs={12} sm={4} ml={12}>
            <Controls.Input name="claim_Id" label="Claim ID" disabled />
          </Grid>
          <Grid item xs={12} sm={8}>
            <Autocomplete
              {...defprops}
              id="productIds"
              // value={formik.values.studentId}
              onChange={(e, value) => {
                console.log('now selecte', value);
                formik.setFieldValue('tarrif_id', value.tariff_id);
                formik.setFieldValue('tarif_Code', value.tariff_code);
                formik.setFieldValue('amtClaimed', value.cost);
                formik.setFieldValue('tariffAmt', value.cost);
                formik.setFieldValue('department_id', value.dept_id);
                formik.setFieldValue('award', 'A');
                formik.setFieldValue('status_code', 'I');
                formik.setFieldValue('currency_id', 3);
                formik.setFieldValue('units', 1);
                formik.setFieldValue('userId', sessionStorage.getItem('oldRefId'));
                formik.setFieldValue('userRefId', sessionStorage.getItem('oldRefId'));
                formik.setFieldValue('treatmentDate', moment().format('yyyy-MM-DD'));
                setTariffCode(value.tariff_code);
              }}
              renderInput={(params) => (
                <TextField {...params} label="Select Product..." variant="standard" />
              )}
            />
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormControl fullWidth>
              <InputLabel id="sertxt">Service Type</InputLabel>
              <Select
                id="serviceTypeId"
                value={formik.values.serviceTypeId}
                name="serviceTypeId"
                fullWidth
                size="small"
                variant="outlined"
                onChange={(e) => {
                  formik.setFieldValue('serviceTypeId', e.target.value);
                }}
                error={Boolean(touched.serviceTypeId && errors.serviceTypeId)}
                helperText={touched.serviceTypeId && errors.serviceTypeId}
              >
                <MenuItem key="" value="">
                  Not Selected
                </MenuItem>
                {services.map((item) => (
                  <MenuItem key={item.refId} value={item.refId}>
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={8}>
            <FormControl fullWidth>
              <InputLabel htmlFor="unitslabel">Units/Visits</InputLabel>
              <Input
                id="units"
                type="text"
                value={formik.values.units}
                onChange={(e) => {
                  formik.setFieldValue('units', e.target.value);
                  formik.setFieldValue('amtClaimed', e.target.value * formik.values.tariffAmt);
                }}
              />
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.DateTime name="treatmentDate" label="Service Date" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="tariffAmt" label="Tariff Fee" disabled />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="amtClaimed" label="Amt Claimed" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <Controls.InputNumber name="amtPaid" label="Awarded" disabled />
          </Grid>

          <Grid margin={2} container direction="row" justifyContent="right" alignItems="right">
            <Grid item xs={12} sm={1} marginRight={1}>
              <Button
                type="submit"
                variant="contained"
                startIcon={<SaveIcon />}
                disabled={formik.values.treatmentDate === '' || formik.values.tarrif_id === 0}
              >
                Save...
              </Button>
            </Grid>
          </Grid>
        </Grid>
        <Controls.Notification notify={notify} setNotify={setNotify} />
      </Form>
    </FormikProvider>
  );
}

export default ClaimsLineInit;
